import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button, Modal, Slider, TextField, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { TagsInput } from "react-tag-input-component";
import { toast } from "react-toastify";
import animation from "../assets/animation.gif";
import BackwardIcon from "../assets/backward10sec.png";
import close from "../assets/close.png";
import done from "../assets/done.png";
import ForwardIcon from "../assets/forward10sec.png";
import logo from "../assets/logo.png";
import PauseIcon from "../assets/pausebutton.png";
import PlayIcon from "../assets/playbutton.png";
import previewupload from "../assets/previewupload.png";
import SoundIcon from "../assets/sound.png";
import upload from "../assets/upload.png";
import MuteIcon from "../assets/volumeMute.png";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const AdminDashboard = () => {
  const [adminMenu, setAdminMenu] = useState("NewsLetter");
  const [isLogin, setIsLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [adminDetails, setAdminDetails] = useState({ email: "", password: "" });
  const [allNewsLetter, setAllNewsLetter] = useState([]);
  const [allYourUploades, setAllYourUploades] = useState([]);
  const [uploadFile, setUploadedFile] = useState([]);
  const [allPodcast, setAllpodcasts] = useState([]);
  const [state, setState] = useState({
    newletter: {
      isEdit: false,
      modalStatus: false,
      heading: "",
      content: "",
      contentUrl: "",
      sub_description: "",
      edition: "",
      image:
        "https://images.ctfassets.net/ut7rzv8yehpf/1DhC3uX3EeKnjU02LWyTXH/9c82e6ae82662ed5903eafb40d888d90/8_Main_Types_of_Heart_Disease.jpg?w=1800&h=900&fl=progressive&q=50&fm=jpg",
    },
    podcast: {
      title: "",
      description: "",
      contentUrl: "",
      audio_url: "",
      isEdit: false,
      modalStatus: false,
    },
    sources: {
      tags: [],
      url: "",
      isEdit: false,
    },
  });
  const [allSources, setAllSources] = useState([]);
  const [currentPlaying, setCurrentPlaying] = useState(null);
  const [progress, setProgress] = useState({});
  const [muted, setMuted] = useState({});
  const [durations, setDurations] = useState({});
  const audioRefs = useRef({});
  const togglePlayPause = (index) => {
    const currentAudio = audioRefs.current[index];

    if (!currentAudio) return;

    if (currentPlaying === index) {
      currentAudio.pause();
      setCurrentPlaying(null);
    } else {
      // Pause all other audios before playing the new one
      Object.values(audioRefs.current).forEach((audio) => {
        if (audio) audio.pause();
      });

      currentAudio.play().catch((e) => console.error("Playback error:", e));
      setCurrentPlaying(index);
    }
  };
  const uploadFileConterToPodcast = async (e) => {
    const media = uploadFile[0];
    const fd = new FormData();
    fd.append("user_id", "1");
    fd.append("file", media);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/convert_pdf_to_podcast",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: fd,
    };
    try {
      setIsLoading(true);
      const response = await axios.request(config);
      setIsLoading(false);
      setState({
        ...state,
        podcast: { ...state.podcast, modalStatus: false },
      });
      setUploadedFile([]);
      // setCurrentButton("Your Uploads");
      // setState({
      //   ...state,
      //   newletter: { ...state.newletter, image: response.data.file_url },
      // });
      // console.log("response", );
    } catch (error) {
      // setUploadedFile([]);
      console.log("sdfsdf", error);
      setIsLoading(false);
      toast.error(error?.response?.data?.message ?? "Something went wrong!");
    }
  };

  // Function to seek audio forward/backward
  const seekAudio = (index, time) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      currentAudio.currentTime = Math.max(0, currentAudio.currentTime + time);
    }
  };

  // Function to toggle mute/unmute
  const toggleMute = (index) => {
    setMuted((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
    if (audioRefs.current[index]) {
      audioRefs.current[index].muted = !audioRefs.current[index].muted;
    }
  };

  // Function to update progress time
  const updateTime = (index) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      setProgress((prev) => ({
        ...prev,
        [index]: (currentAudio.currentTime / currentAudio.duration) * 100 || 0,
      }));
    }
  };

  // Function to update duration when metadata loads
  const updateDuration = (index) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      setDurations((prev) => ({
        ...prev,
        [index]: formatTime(currentAudio.duration),
      }));
    }
  };
  // Function to update audio time when slider is moved
  const handleSliderChange = (index, value) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      currentAudio.currentTime = (value / 100) * currentAudio.duration;
      setProgress((prev) => ({
        ...prev,
        [index]: value,
      }));
    }
  };
  // Format time (mm:ss)
  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  const generateImageUrl = async (e) => {
    const media = e.target.files[0];
    const fd = new FormData();
    fd.append("file", media);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/upload",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: fd,
    };
    try {
      const response = await axios.request(config);
      setState({
        ...state,
        newletter: { ...state.newletter, image: response.data.file_url },
      });
      // console.log("response", );
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  console.log("fsdfsdf", state.podcast);
  const generateHTMLUrl = async (e) => {
    const media = e.target.files[0];
    const fd = new FormData();
    fd.append("file", media);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/upload",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: fd,
    };
    try {
      const response = await axios.request(config);
      setState({
        ...state,
        newletter: { ...state.newletter, contentUrl: response.data.file_url },
      });
      // console.log("response", );
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  const fetchAllNewsletters = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/newsletters",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await axios.request(config);
    setAllNewsLetter(response?.data);
  };
  const fetchAllSources = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/sources",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axios.request(config);
    setAllSources(response?.data);
  };
  const updatePodcast = async () => {
    // console.log("state", state);
    delete state?.sources?.modalStatus;
    delete state?.sources?.isEdit;
    if (!state?.podcast?.title || !state?.podcast?.description) {
      toast.error("Require detail is missing !");
      return;
    }
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/podcasts/${state?.podcast.id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...state?.podcast, tags: JSON.stringify(state?.sources.tags) },
    };

    try {
      const response = await axios.request(config);
      toast.success("Updated !");
      fetchAllSources();
    } catch (error) {
      console.log("error", error);
      toast.error("Something went wrong!");
    }
  };
  const fetchAllPodcast = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/podcasts/user/1",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.request(config);
      setAllpodcasts(response?.data);
    } catch (error) {}
  };
  const handleDeleteNewsLetter = async (id) => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/newsletters/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: state?.newletter,
    };

    try {
      const response = await axios.request(config);
      toast.success("Deleted!");
      fetchAllNewsletters();
    } catch (error) {
      console.log("error", error);
      toast.error("Something went wrong!");
    }
  };
  const handleDeletePodcast = async (id) => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/podcasts/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: state?.podcast,
    };

    try {
      const response = await axios.request(config);
      toast.success("Deleted!");
      fetchAllPodcast();
    } catch (error) {
      console.log("error", error);
      toast.error("Something went wrong!");
    }
  };
  const addNewNewsLetter = async () => {
    delete state?.newletter?.modalStatus;
    if (!state?.newletter?.heading || !state?.newletter?.contentUrl) {
      toast.error("Require detail is missing !");
      return;
    }
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/newsletters",
      headers: {
        "Content-Type": "application/json",
      },
      data: state?.newletter,
    };

    try {
      const response = await axios.request(config);
      toast.success("Added!");
      fetchAllNewsletters();
    } catch (error) {
      console.log("error", error);
      toast.error("Something went wrong!");
    }
  };
  const addNewSources = async () => {
    console.log("state?.sources", state.sources);
    delete state?.sources?.modalStatus;
    if (!state?.sources?.url) {
      toast.error("Require detail is missing !");
      return;
    }
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/sources",
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...state?.sources, tags: JSON.stringify(state?.sources.tags) },
    };

    try {
      const response = await axios.request(config);
      toast.success("Added!");
      fetchAllSources();
    } catch (error) {
      console.log("error", error);
      toast.error("Something went wrong!");
    }
  };
  const updateNewsLetter = async () => {
    delete state?.newletter?.modalStatus;
    if (!state?.newletter?.heading || !state?.newletter?.contentUrl) {
      toast.error("Require detail is missing !");
      return;
    }
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/newsletters/${state?.newletter.id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: state?.newletter,
    };

    try {
      const response = await axios.request(config);
      toast.success("Updated !");
      fetchAllNewsletters();
    } catch (error) {
      console.log("error", error);
    }
  };
  const updateSources = async () => {
    console.log("state", state);
    delete state?.sources?.modalStatus;
    delete state?.sources?.isEdit;
    if (!state?.sources?.url) {
      toast.error("Require detail is missing !");
      return;
    }
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/sources/${state?.sources.id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...state?.sources, tags: JSON.stringify(state?.sources.tags) },
    };

    try {
      const response = await axios.request(config);
      toast.success("Updated !");
      fetchAllSources();
    } catch (error) {
      console.log("error", error);
      toast.error("Something went wrong!");
    }
  };
  const handleDeleteSources = async (id) => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/sources/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: state?.sources,
    };

    try {
      const response = await axios.request(config);
      toast.success("Deleted!");
      fetchAllSources();
    } catch (error) {
      console.log("error", error);
      toast.error("Something went wrong!");
    }
  };
  const handleAdminLogin = async () => {
    if (
      adminDetails.email == "admin@admin.com" &&
      adminDetails.password == "password"
    ) {
      localStorage.setItem("orgData", "klcxmvksdvdsfsdfmfrk33rklk");
      setIsLogin(true);
    } else {
      toast.error("Wrong Credentials!");
    }
  };
  useEffect(() => {
    if (window) {
      if (localStorage.getItem("orgData")) {
        setIsLogin(true);
      }
    }
    fetchAllNewsletters();
    fetchAllSources();
    fetchAllPodcast();
  }, []);
  return (
    <>
      {isLogin ? (
        <div>
          <Box
            display={"flex"}
            justifyContent={"space-around"}
            alignItems={"center"}
            padding={"10px"}
            borderBottom={1}
          >
            <Box display={"flex"} alignItems={"center"}>
              {" "}
              <img src={logo} />{" "}
              <span
                style={{
                  fontWeight: "400",
                  color: "#C789E4",
                  fontSize: "20px",
                }}
              >
                {" "}
                Admin
              </span>
            </Box>
            <Box sx={{ gap: "10px", display: "flex" }}>
              <Button
                variant={adminMenu == "NewsLetter" ? "contained" : "outlined"}
                onClick={() => {
                  setAdminMenu("NewsLetter");
                }}
              >
                NewsLetter{" "}
              </Button>
              <Button
                variant={adminMenu == "Postcast" ? "contained" : "outlined"}
                onClick={() => {
                  setAdminMenu("Postcast");
                }}
              >
                Podcast{" "}
              </Button>
              <Button
                variant={adminMenu == "Sources" ? "contained" : "outlined"}
                onClick={() => {
                  setAdminMenu("Sources");
                }}
              >
                Sources{" "}
              </Button>
              <Button
                // variant={"outlined"}
                onClick={() => {
                  localStorage.removeItem("orgData");
                  setIsLogin(false);
                }}
              >
                Logout{" "}
              </Button>
            </Box>
          </Box>
          <Box>
            {adminMenu == "NewsLetter" ? (
              <>
                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  padding={"10px"}
                >
                  <Button
                    onClick={() => {
                      setState({
                        ...state,
                        newletter: {
                          ...state.newletter,
                          sub_description: "",
                          modalStatus: true,
                          edition: "",
                          heading: "",
                          content: "",
                          contentUrl: "",
                          image: "",
                          isEdit: false,
                        },
                      });
                    }}
                  >
                    {" "}
                    Add Newsletter
                  </Button>
                </Box>
                <DataGrid
                  getRowId={(row) => row.id}
                  rows={
                    allNewsLetter
                    // .map((item) => ({
                    //   ...item,
                    //   templet_name: item.message?.name,
                    // }))
                    // .reverse()
                  }
                  columns={[
                    {
                      headerName: "ID",
                      field: "id",
                      flex: 1,
                    },
                    {
                      headerName: "IMAGE",
                      field: "image",
                      flex: 1,
                      renderCell: (dataa) => {
                        return (
                          <Box>
                            <img
                              src={dataa?.row?.image}
                              style={{
                                cursor: "pointer",
                                width: "93px",
                                height: "50px",
                              }}
                            />{" "}
                          </Box>
                        );
                      },
                    },
                    // {
                    //   headerName: data.sender,
                    //   field: "sender_mobile",
                    //   flex: 1,
                    //   renderCell: (dataa) => {
                    //     return (
                    //       <Tooltip title={dataa.row?.sender_mobile}>
                    //         {dataa.row?.sender_mobile}
                    //       </Tooltip>
                    //     );
                    //   },
                    // },
                    {
                      headerName: "HEADING",
                      field: "heading",
                      flex: 1,
                      renderCell: (dataa) => {
                        return (
                          <Tooltip title={dataa.row?.heading}>
                            <p>+{dataa.row?.heading}</p>
                          </Tooltip>
                        );
                      },
                    },
                    {
                      headerName: "SUB CONTENT",
                      field: "sub_description",
                      flex: 1,
                      // renderCell: (dataa) => {
                      //   return (
                      //     <Tooltip title={dataa.row?.content}>
                      //       {dataa.row?.content}
                      //     </Tooltip>
                      //   );
                      // },
                    },
                    {
                      headerName: "CONTENT URL",
                      field: "contentUrl",
                      flex: 1,
                      // renderCell: (dataa) => {
                      //   return (
                      //     <Tooltip title={dataa.row?.content}>
                      //       {dataa.row?.content}
                      //     </Tooltip>
                      //   );
                      // },
                    },
                    {
                      headerName: "CREATED_AT",
                      field: "created_at",
                      flex: 1,
                      //   renderCell: (dataa) => {
                      //     return <Tooltip title={"sd"}>sd</Tooltip>;
                      //   },
                    },
                    {
                      headerName: "ACTION",
                      //   field: "ac",
                      flex: 1,
                      renderCell: (dataa) => {
                        return (
                          <Box>
                            <EditIcon
                              style={{ cursor: "pointer", color: "#4466ba" }}
                              onClick={() => {
                                // onClick={() => {
                                setState({
                                  ...state,
                                  newletter: {
                                    ...state.newletter,
                                    id: dataa.row.id,
                                    modalStatus: true,
                                    sub_description: "",
                                    image: dataa.row.image,
                                    edition: dataa.row.edition,
                                    heading: dataa.row.heading,
                                    contentUrl: dataa?.row?.contentUrl,
                                    content: dataa.row.content,
                                    sub_description: dataa.row.sub_description,
                                    isEdit: true,
                                  },
                                });
                                // }}
                              }}
                            />{" "}
                            <DeleteIcon
                              style={{ cursor: "pointer", color: "#e36161" }}
                              onClick={() => {
                                if (window.confirm("Are you sure ?")) {
                                  handleDeleteNewsLetter(dataa.row.id);
                                }
                              }}
                            />{" "}
                          </Box>
                        );
                      },
                    },
                  ]}
                  // pageSize={50}
                  // rowsPerPageOptions={[50]}
                  // checkboxSelection={false}s
                  // components={{
                  //   Toolbar: CustomToolbar,
                  // }}
                  slots={{ toolbar: GridToolbar }}
                  sx={{
                    boxShadow: 0,
                    borderRadius: 4,
                    border: 0,
                    fontSize: 13,
                    padding: 2,
                  }}
                />
              </>
            ) : adminMenu == "Postcast" ? (
              <>
                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  padding={"10px"}
                >
                  <Button
                    onClick={() => {
                      setState({
                        ...state,
                        podcast: {
                          ...state.podcast,
                          sub_description: "",
                          modalStatus: true,
                          edition: "",
                          heading: "",
                          content: "",
                          contentUrl: "",
                          image: "",
                          isEdit: false,
                        },
                      });
                    }}
                  >
                    {" "}
                    Add Podcast
                  </Button>
                </Box>{" "}
                <DataGrid
                  getRowId={(row) => row.id}
                  rows={allPodcast}
                  columns={[
                    {
                      headerName: "ID",
                      field: "id",
                      flex: 1,
                    },
                    {
                      headerName: "HEADING",
                      field: "title",
                      flex: 1,
                    },
                    {
                      headerName: "DESCRIPTION",
                      field: "description",
                      flex: 1,
                    },
                    {
                      headerName: "CREATED_AT",
                      field: "created_at",
                      flex: 1,
                      //   renderCell: (dataa) => {
                      //     return <Tooltip title={"sd"}>sd</Tooltip>;
                      //   },
                    },
                    {
                      headerName: "STATUS",
                      field: "status",
                      flex: 1,
                      //   renderCell: (dataa) => {
                      //     return <Tooltip title={"sd"}>sd</Tooltip>;
                      //   },
                    },
                    {
                      headerName: "ACTION",
                      //   field: "ac",
                      flex: 1,
                      renderCell: (dataa) => {
                        return (
                          <Box>
                            {dataa.row.status == "completed" && (
                              <>
                                {" "}
                                <EditIcon
                                  style={{
                                    cursor: "pointer",
                                    color: "#4466ba",
                                  }}
                                  onClick={() => {
                                    // onClick={() => {
                                    setState({
                                      ...state,
                                      podcast: {
                                        ...state.podcast,
                                        ...dataa.row,
                                        modalStatus: true,
                                        isEdit: true,
                                      },
                                    });
                                    // }}
                                  }}
                                />{" "}
                                <DeleteIcon
                                  style={{
                                    cursor: "pointer",
                                    color: "#e36161",
                                  }}
                                  onClick={() => {
                                    if (window.confirm("Are you sure ?")) {
                                      handleDeletePodcast(dataa.row.id);
                                    }
                                  }}
                                />{" "}
                              </>
                            )}
                          </Box>
                        );
                      },
                    },
                  ]}
                  slots={{ toolbar: GridToolbar }}
                  sx={{
                    boxShadow: 0,
                    borderRadius: 4,
                    border: 0,
                    fontSize: 13,
                    padding: 2,
                  }}
                />
              </>
            ) : adminMenu == "Sources" ? (
              <>
                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  padding={"10px"}
                >
                  <Button
                    onClick={() => {
                      setState({
                        ...state,
                        sources: {
                          ...state.sources,
                          modalStatus: true,
                          url: "",
                          tags: [],
                          isEdit: false,
                        },
                      });
                    }}
                  >
                    {" "}
                    Add Sources
                  </Button>
                </Box>
                <DataGrid
                  getRowId={(row) => row.id}
                  rows={allSources}
                  columns={[
                    {
                      headerName: "ID",
                      field: "id",
                      flex: 1,
                    },
                    {
                      headerName: "URL",
                      field: "url",
                      flex: 1,
                    },
                    {
                      headerName: "CREATED_AT",
                      field: "created_at",
                      flex: 1,
                    },
                    {
                      headerName: "ACTION",
                      //   field: "ac",
                      flex: 1,
                      renderCell: (dataa) => {
                        return (
                          <Box>
                            <EditIcon
                              style={{ cursor: "pointer", color: "#4466ba" }}
                              onClick={() => {
                                setState({
                                  ...state,
                                  sources: {
                                    ...state.sources,
                                    id: dataa?.row?.id,
                                    modalStatus: true,
                                    url: dataa?.row?.url,
                                    tags: JSON.parse(dataa?.row?.tags || {}),
                                    isEdit: true,
                                  },
                                });
                              }}
                            />{" "}
                            <DeleteIcon
                              style={{ cursor: "pointer", color: "#e36161" }}
                              onClick={() => {
                                if (window.confirm("Are you sure ?")) {
                                  handleDeleteSources(dataa.row.id);
                                }
                              }}
                            />{" "}
                          </Box>
                        );
                      },
                    },
                  ]}
                  slots={{ toolbar: GridToolbar }}
                  sx={{
                    boxShadow: 0,
                    borderRadius: 4,
                    border: 0,
                    fontSize: 13,
                    padding: 2,
                  }}
                />
              </>
            ) : (
              <></>
            )}
          </Box>
          {/* <Button onClick={handleOpen}>Open modal</Button> */}
          <Modal
            open={state?.newletter?.modalStatus}
            onClose={() => {
              setState({
                ...state,
                newletter: { ...state.newletter, modalStatus: false },
              });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                p: 4,
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                // alignItems: "center",
              }}
            >
              <Box> {state.newletter.isEdit ? "Edit" : "Add"} Newsletter</Box>
              <TextField
                id="outlined-basic"
                label="Heading"
                variant="outlined"
                value={state?.newletter.heading}
                onChange={(e) => {
                  setState({
                    ...state,
                    newletter: {
                      ...state.newletter,
                      heading: e?.target?.value,
                    },
                  });
                }}
              />
              <TextField
                id="outlined-basic"
                label="Sub Content"
                variant="outlined"
                value={state?.newletter.sub_description}
                onChange={(e) => {
                  setState({
                    ...state,
                    newletter: {
                      ...state.newletter,
                      sub_description: e?.target?.value,
                    },
                  });
                }}
              />
              <TextField
                id="outlined-basic"
                label="Edition"
                variant="outlined"
                value={state?.newletter?.edition}
                onChange={(e) => {
                  setState({
                    ...state,
                    newletter: {
                      ...state.newletter,
                      edition: e?.target?.value,
                    },
                  });
                }}
              />
              <Box display={"flex"}>
                Image
                {state.newletter.image && (
                  <img
                    src={state.newletter.image}
                    width={"60px"}
                    height={"60px"}
                  />
                )}
                <input
                  type="file"
                  style={{ border: "1px solid #d5d5d5", padding: "5px" }}
                  onChange={generateImageUrl}
                />
              </Box>
              <Box display={"flex"}>
                HTML
                {state.newletter.contentUrl && (
                  <img src={done} width={"60px"} height={"60px"} />
                )}
                <input
                  type="file"
                  accept=".html"
                  style={{ border: "1px solid #d5d5d5", padding: "5px" }}
                  onChange={generateHTMLUrl}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "20px" }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setState({
                      ...state,
                      newletter: {
                        ...state.newletter,
                        sub_description: "",
                        modalStatus: false,
                        heading: "",
                        content: "",
                        edition: "",
                        image: "",
                        contentUrl: "",
                        isEdit: false,
                      },
                    });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={
                    state.newletter.isEdit ? updateNewsLetter : addNewNewsLetter
                  }
                >
                  {state.newletter.isEdit ? "Update" : "Save"}
                </Button>
              </Box>
            </Box>
          </Modal>
          <Modal
            open={state?.sources?.modalStatus}
            onClose={() => {
              setState({
                ...state,
                sources: { ...state.sources, modalStatus: false },
              });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                p: 4,
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                // alignItems: "center",
              }}
            >
              <Box> {state?.sources?.isEdit ? "Edit" : "Add"} sources</Box>
              <TagsInput
                value={state?.sources?.tags}
                onChange={(e) => {
                  setState({
                    ...state,
                    sources: { ...state.sources, tags: e },
                  });
                }}
                name="tags"
                placeHolder="Enter Tags"
              />
              <span style={{ marginTop: "-22px" }}>
                Press enter to add new tag
              </span>
              <TextField
                id="outlined-basic"
                label="URL"
                variant="outlined"
                value={state?.sources?.url}
                onChange={(e) => {
                  setState({
                    ...state,
                    sources: { ...state?.sources, url: e?.target?.value },
                  });
                }}
              />
              <Box sx={{ display: "flex", gap: "20px" }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setState({
                      ...state,
                      sources: {
                        ...state.sources,
                        tags: [],
                        url: "",
                        isEdit: false,
                      },
                    });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={state.sources.isEdit ? updateSources : addNewSources}
                >
                  {state.sources.isEdit ? "Update" : "Save"}
                </Button>
              </Box>
            </Box>
          </Modal>
          <Modal
            open={state?.podcast?.modalStatus}
            onClose={() => {
              setState({
                ...state,
                podcast: { ...state.podcast, modalStatus: false },
              });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                p: 4,
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                // alignItems: "center",
              }}
            >
              <Box> {state.podcast.isEdit ? "Edit" : "Add"} Podcast</Box>
              {state.podcast.isEdit ? (
                <>
                  {" "}
                  <TextField
                    id="outlined-basic"
                    label="Title"
                    variant="outlined"
                    value={state?.podcast.title}
                    onChange={(e) => {
                      setState({
                        ...state,
                        podcast: {
                          ...state.podcast,
                          title: e?.target?.value,
                        },
                      });
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    label="Description"
                    variant="outlined"
                    value={state?.podcast.description}
                    onChange={(e) => {
                      setState({
                        ...state,
                        podcast: {
                          ...state.podcast,
                          description: e?.target?.value,
                        },
                      });
                    }}
                  />
                  <Box
                    sx={{
                      fontSize: "14px",
                      marginTop: "8px",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: "#8C837D",
                    }}
                  >
                    {state.podcast?.description ??
                      "Lorem ipsum dolor sit amet consectetur."}
                  </Box>
                  {/* Controls */}
                  <Box
                    display={"flex"}
                    marginTop={"22px"}
                    alignItems={"center"}
                  >
                    {/* Play/Pause Button */}
                    <img
                      src={
                        currentPlaying === state.podcast.id
                          ? PauseIcon
                          : PlayIcon
                      }
                      alt="Play/Pause"
                      style={{
                        width: "50px",
                        height: "50px",
                        cursor: "pointer",
                      }}
                      onClick={() => togglePlayPause(state.podcast.id)}
                    />

                    {/* Audio Element */}
                    <audio
                      ref={(el) => (audioRefs.current[state.podcast.id] = el)}
                      src={state.podcast.audio_url}
                      onTimeUpdate={() => updateTime(state.podcast.id)}
                      onLoadedMetadata={() => updateDuration(state.podcast.id)}
                      onEnded={() => setCurrentPlaying(null)}
                    />

                    {/* Progress & Time */}
                    <Box
                      width={"100%"}
                      display={"flex"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                      marginLeft={"12px"}
                      marginTop={"9px"}
                    >
                      <Slider
                        value={progress[state.podcast.id] || 0}
                        style={{ width: "95%" }}
                        aria-label="progress"
                        min={0}
                        onChange={(e, newValue) =>
                          handleSliderChange(state.podcast.id, newValue)
                        }
                        max={100}
                      />
                      <Box
                        display={"flex"}
                        justifyContent={"space-between"}
                        width={"95%"}
                      >
                        {/* Controls - Rewind, Forward, Mute */}
                        <Box display={"flex"} gap={"10px"}>
                          <img
                            src={BackwardIcon}
                            alt="Rewind 10s"
                            style={{
                              width: "28px",
                              height: "28px",
                              cursor: "pointer",
                            }}
                            onClick={() => seekAudio(state.podcast.id, -10)}
                          />
                          <img
                            src={ForwardIcon}
                            alt="Forward 10s"
                            style={{
                              width: "28px",
                              height: "28px",
                              cursor: "pointer",
                            }}
                            onClick={() => seekAudio(state.podcast.id, 10)}
                          />
                          <img
                            src={muted[state.podcast.id] ? MuteIcon : SoundIcon}
                            alt="Mute/Unmute"
                            style={{
                              width: "28px",
                              height: "28px",
                              cursor: "pointer",
                            }}
                            onClick={() => toggleMute(state.podcast.id)}
                          />
                        </Box>

                        {/* Time Display */}
                        <Box color={"#C789E4"}>
                          {formatTime(
                            audioRefs.current[state?.podcast?.id]
                              ?.currentTime || 0
                          )}{" "}
                          <span>|</span>{" "}
                          {durations[state?.podcast?.id] || "0:00"}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", gap: "20px" }}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setState({
                          ...state,
                          podcast: {
                            ...state.podcast,
                            title: "",
                            description: "",
                            audio_url: "",
                            contentUrl: "",
                            isEdit: false,
                            modalStatus: false,
                          },
                        });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={state.podcast?.isEdit ? updatePodcast : () => {}}
                    >
                      {state.podcast?.isEdit ? "Update" : "Save"}
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Box fontSize={"14px"} marginTop={"20px"}>
                    Transform your research into audio with our innovative
                    podcast feature.
                  </Box>
                  <Box
                    // border={"1px solid red"}
                    marginTop={"20px"}
                    height={"140px"}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    gap={"10px"}
                    style={
                      {
                        // cursor: "pointer",
                      }
                    }
                    className="boxborder"
                    // component={"input"}
                    type="file"
                    component="label"
                    position={"relative"}
                    padding={"10px"}
                  >
                    {/* <input type="file" /> */}
                    {isLoading ? (
                      <img
                        src={animation}
                        style={{ width: "60%", opacity: "0.5" }}
                      />
                    ) : !uploadFile.length ? (
                      <>
                        <img
                          src={upload}
                          style={{ width: "28px", height: "24px" }}
                        />
                        <Box>Drag and drop to upload</Box>
                        {/* {/* <Box>Or</Box> */}
                        <VisuallyHiddenInput
                          type="file"
                          accept=".pdf"
                          onChange={(event) => {
                            setUploadedFile(event.target.files);
                            // setIsLoading(true);
                            // setTimeout(() => {
                            //   setIsLoading(false);
                            // uploadFileConterToPodcast(event);
                            // }, 2000);
                            console.log(event.target.files);
                          }}
                          multiple
                        />{" "}
                      </>
                    ) : (
                      <Box>
                        {" "}
                        <img
                          src={previewupload}
                          style={{ width: "91px", height: "120px" }}
                        />
                        <img
                          src={close}
                          style={{
                            width: "24px",
                            height: "24px",
                            position: "absolute",
                            top: "7%",
                            cursor: "pointer",
                            right: "35%",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setUploadedFile([]);
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                  {isLoading == true && (
                    <Box
                      fontSize={"14px"}
                      marginTop={"20px"}
                      textAlign={"center"}
                    >
                      It will take 2-4 minutes. You can check this in your
                      upload section.{" "}
                    </Box>
                  )}
                  <Box
                    display={"flex"}
                    justifyContent={"flex-end"}
                    marginTop={"10px"}
                    gap="5px"
                  >
                    {isLoading == true && (
                      <Button
                        variant="contained"
                        onClick={() => {
                          setState({
                            ...state,
                            podcast: {
                              ...state.podcast,
                              title: "",
                              description: "",
                              audio_url: "",
                              contentUrl: "",
                              isEdit: false,
                              modalStatus: false,
                            },
                          });
                          fetchAllPodcast();
                        }}
                      >
                        Close
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      disabled={uploadFile.length == 0 || isLoading}
                      onClick={() => {
                        uploadFileConterToPodcast();
                      }}
                    >
                      Generate
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Modal>
        </div>
      ) : (
        <Box>
          <Box
            display={"flex"}
            flexDirection={"column"}
            width={"30%"}
            margin={"auto"}
            gap={"10px"}
            marginTop={"200px"}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              {" "}
              <img src={logo} />{" "}
              <span
                style={{
                  fontWeight: "400",
                  color: "#C789E4",
                  fontSize: "20px",
                }}
              >
                {" "}
                Admin
              </span>
            </Box>
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              value={adminDetails.email}
              onChange={(e) => {
                setAdminDetails({
                  ...adminDetails,
                  email: e?.target?.value,
                });
              }}
            />
            <TextField
              id="outlined-basic"
              label="Password"
              variant="outlined"
              type="password"
              value={adminDetails.password}
              onChange={(e) => {
                setAdminDetails({
                  ...adminDetails,
                  password: e?.target?.value,
                });
              }}
            />
            <Button variant="contained" onClick={handleAdminLogin}>
              {" "}
              Login
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default AdminDashboard;
